import React from 'react';
import bgHero from '../assets/bg-hero.svg';

const Hero = () => {
  return (
    <section className="relative h-[300px] overflow-hidden bg-cover bg-bottom bg-no-repeat" style={{backgroundImage: `url(${bgHero})`}}>
      {/* Overlay para mejorar legibilidad */}
      {/* <div className="absolute inset-0 bg-blue-900/70"></div> */}
      
      {/* Patrón decorativo */}
      {/* <div className="absolute inset-0 bg-white/5">
        <div className="absolute bottom-0 left-0 w-full h-20 bg-gradient-to-t from-white to-transparent"></div>
      </div> */}
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
        <div className="text-center">
          {/* Main Title */}
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-6">
            Intelligent Image Analysis
          </h1>
          
          {/* Subtitle */}
          <p className="text-xl md:text-2xl text-blue-100 mb-8 max-w-3xl mx-auto">
            Harness the power of artificial intelligence to analyze and process your images efficiently
          </p>
        </div>
      </div>
    </section>
  );
};

export default Hero;
